import SignalDialog from '@/components/signal/SignalDialog';
import { useApplication } from '@/hooks/useApplication';
import { getMostSevereLevel, validateSignals } from '@/util/validation/validation';
import StreamIcon from '@mui/icons-material/Stream';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

const TreeSignals: FC = () => {
  const { application } = useApplication();
  const [openManager, setOpenManager] = useState(false);
  const errors = (application && validateSignals(application.signals, application.subroutines)) || [];

  return (
    <>
      <StyledTreeItem
        itemId='signals'
        label={
          <TreeLabel
            icon={StreamIcon}
            label='Signals'
            {...(!!errors.length && { error: getMostSevereLevel(errors) })}
          />
        }
        onClick={() => setOpenManager(true)}
      />
      <SignalDialog open={openManager} onClose={() => setOpenManager(false)} />
    </>
  );
};

export default TreeSignals;
